<!-- results-table.component.html -->
<h1 mat-dialog-title><strong>{{action | translate}}</strong> evaluación <span *ngIf="action == 'Delete'"> {{LOCAL_DATA.nombre}}</span></h1>
<div mat-dialog-content>
      <mat-form-field *ngIf="action != 'Delete'" class="select-list">
        <input placeholder="Nombre" matInput [(ngModel)]="LOCAL_DATA.nombre">
      </mat-form-field>
      <mat-form-field *ngIf="action != 'Delete'" class="select-list">
        <mat-label>Tipo de evaluación</mat-label>
        <mat-select [(ngModel)]="LOCAL_DATA.tipo" class="roleSelect">
            <mat-option *ngFor="let tipoEvaluacion of tiposEvaluacion" [value]="tipoEvaluacion">
                {{tipoEvaluacion.nombre}}
            </mat-option>
        </mat-select>
      </mat-form-field>

      <div *ngIf="action != 'Delete'">
        <mat-label>Estructura jerárquica / Nodo</mat-label>
        <span *ngIf="LOCAL_DATA.nodoEstructuraJerarquica!=null" fxFlex class="px-20">{{LOCAL_DATA.estructuraJerarquica?.nombre}} / {{LOCAL_DATA.nodoEstructuraJerarquica?.nombre}}</span>
        <button mat-button (click)="openDialog()">Seleccionar Nodo</button>

      </div>

      <mat-form-field *ngIf="action != 'Delete'" class="select-list">
        <mat-label>Escenario</mat-label>
        <mat-select [(ngModel)]="LOCAL_DATA.escenario" class="roleSelect">
            <mat-option *ngFor="let escenario of escenarios" [value]="escenario">
                {{escenario.nombre}}
            </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field *ngIf="action != 'Delete'" class="select-list">
        <mat-label>Dueño</mat-label>
        <mat-select [(ngModel)]="LOCAL_DATA.owner" class="roleSelect" >
            <mat-option *ngFor="let usuario of LOCAL_DATA.nodoEstructuraJerarquica?.usuarios" [value]="usuario">
                {{usuario.nombreCompleto}}
            </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field color="accent" appearance="fill" *ngIf="action != 'Delete'">
      <mat-label>Fecha de Inicio</mat-label>
      <input matInput [matDatepicker]="picker1" [(ngModel)]="LOCAL_DATA.fechaInicio">
      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>

      <mat-form-field color="accent" appearance="fill" *ngIf="action != 'Delete'">
      <mat-label>Fecha de Finalización</mat-label>
      <input matInput [matDatepicker]="picker2" [(ngModel)]="LOCAL_DATA.fechaFin">
      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
      <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>


</div>
<div mat-dialog-actions>
  <button mat-button (click)="doAction()">{{action | translate}}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
